/* Explicit Quick view labels and a product-photograph viewer. No commerce changes. */
(() => {
  'use strict';
  if (window.BMGImageControls) { window.BMGImageControls.init(); return; }
  const instances = new Map();
  const plainClick = e => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  function collection(root) {
    const grid = root.querySelector('.bmg-print-shop__grid');
    if (!grid || instances.has(root)) return;
    let frame = 0;
    const changed = new Map();
    const scan = () => {
      frame = 0;
      grid.querySelectorAll('[data-bmg-view-larger]').forEach(button => {
        if (!changed.has(button)) changed.set(button, {label:button.getAttribute('aria-label'), title:button.getAttribute('title'), popup:button.getAttribute('aria-haspopup')});
        if (!button.querySelector('.bmg-quick-view-label')) {
          const label = document.createElement('span');
          label.className = 'bmg-quick-view-label';
          label.textContent = 'Quick view';
          button.replaceChildren(label);
        }
        const name = button.closest('[data-title]')?.dataset.title || 'artwork';
        button.setAttribute('aria-label', 'Quick view: ' + name);
        button.setAttribute('aria-haspopup', 'dialog');
        button.title = 'Quick view';
      });
      if (changed.size) root.classList.add('bmg-image-controls');
    };
    const observer = new MutationObserver(() => { if (!frame) frame = requestAnimationFrame(scan); });
    observer.observe(grid, {childList:true, subtree:true});
    instances.set(root, () => {
      observer.disconnect(); cancelAnimationFrame(frame);
      root.classList.remove('bmg-image-controls');
      changed.forEach((original, button) => {
        if (!button.hasAttribute('data-bmg-view-larger')) return;
        button.querySelector('.bmg-quick-view-label')?.remove();
        if (!button.textContent.trim() && !button.querySelector('svg')) button.textContent = 'View larger';
        [['aria-label',original.label],['title',original.title],['aria-haspopup',original.popup]].forEach(([name,value]) => value === null ? button.removeAttribute(name) : button.setAttribute(name,value));
      });
      instances.delete(root);
    });
    scan();
  }
  function product(root) {
    if (instances.has(root)) return;
    const template = document.querySelector('[data-bmg-product-enlarge-template]');
    const image = root.querySelector('.bmg-product-page__hero-image');
    const hero = image?.closest('.bmg-product-page__hero');
    if (!template || !image || !hero) return;
    let fullURL;
    try {
      fullURL = new URL(template.dataset.image, location.href);
      if (fullURL.protocol !== 'https:' || (fullURL.origin !== location.origin && fullURL.hostname !== 'cdn.shopify.com')) return;
    } catch (_) { return; }
    const abort = new AbortController();
    const on = (target, name, callback, options = {}) => target?.addEventListener(name, callback, {...options, signal:abort.signal});
    const tools = document.createElement('div'); tools.className = 'bmg-shell bmg-product-image-tools';
    const launch = document.createElement('a');
    launch.href = fullURL.href; launch.target = '_blank'; launch.rel = 'noopener';
    launch.className = 'bmg-product-image-enlarge';
    launch.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4H4v5m11-5h5v5M4 15v5h5m11-5v5h-5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Enlarge image</span>';
    launch.setAttribute('aria-label', 'Enlarge image: ' + template.dataset.title);
    tools.append(launch); hero.after(tools);
    if (!window.HTMLDialogElement || typeof HTMLDialogElement.prototype.showModal !== 'function') {
      instances.set(root, () => { abort.abort(); tools.remove(); instances.delete(root); });
      return;
    }
    const dialog = template.content.querySelector('dialog').cloneNode(true);
    document.body.append(dialog);
    const viewport = dialog.querySelector('[data-enlarge-viewport]');
    const canvas = dialog.querySelector('[data-enlarge-canvas]');
    const photo = dialog.querySelector('[data-enlarge-image]');
    const close = dialog.querySelector('[data-enlarge-close]');
    const zoom = dialog.querySelector('[data-enlarge-zoom]');
    const status = dialog.querySelector('[data-enlarge-status]');
    let enlarged = false, saved = null, styleBackup = [], restoreFrame = 0, resizeFrame = 0;
    let fullImage = null, loaded = false, disposed = false, generation = 0;
    const width = Math.max(1, Number(template.dataset.width) || 1);
    const height = Math.max(1, Number(template.dataset.height) || 1);
    const bodyProperties = ['position','top','left','right','width','overflow','padding-right'];
    launch.setAttribute('aria-haspopup','dialog');
    launch.setAttribute('aria-controls',dialog.id);
    root.classList.add('bmg-product-enlarge-ready');
    function measure(center = false) {
      if (!dialog.open) return;
      const vw = viewport.clientWidth, vh = viewport.clientHeight;
      const fit = Math.max(.001, Math.min(Math.max(1,vw-24)/width, Math.max(1,vh-24)/height));
      const factor = enlarged ? 2 : 1;
      const dw = width*fit*factor, dh = height*fit*factor;
      canvas.style.width = Math.max(vw,dw+24)+'px';
      canvas.style.height = Math.max(vh,dh+24)+'px';
      photo.style.width = dw+'px'; photo.style.height = dh+'px';
      viewport.classList.toggle('is-zoomed',enlarged);
      zoom.textContent = enlarged ? 'Fit image' : 'Zoom in';
      zoom.setAttribute('aria-pressed',String(enlarged));
      if (center) { viewport.scrollLeft=(canvas.offsetWidth-vw)/2; viewport.scrollTop=(canvas.offsetHeight-vh)/2; }
    }
    function lock() {
      if (saved) return;
      saved={x:scrollX,y:scrollY};
      styleBackup=bodyProperties.map(name=>[name,document.body.style.getPropertyValue(name),document.body.style.getPropertyPriority(name)]);
      const scrollbar=innerWidth-document.documentElement.clientWidth;
      const padding=parseFloat(getComputedStyle(document.body).paddingRight)||0;
      document.body.style.position='fixed'; document.body.style.top=-saved.y+'px';
      document.body.style.left='0';document.body.style.right='0';document.body.style.width='100%';document.body.style.overflow='hidden';
      if(scrollbar>0)document.body.style.paddingRight=padding+scrollbar+'px';
    }
    function unlock(focus = true) {
      if (!saved) return;
      const position=saved;saved=null;
      styleBackup.forEach(([name,value,priority])=>value?document.body.style.setProperty(name,value,priority):document.body.style.removeProperty(name));
      styleBackup=[];
      scrollTo({left:position.x,top:position.y,behavior:'instant'});
      if(focus && launch.isConnected)launch.focus({preventScroll:true});
      cancelAnimationFrame(restoreFrame);
      if(!disposed)restoreFrame=requestAnimationFrame(()=>scrollTo({left:position.x,top:position.y,behavior:'instant'}));
    }
    function open(event) {
      if (event && !plainClick(event)) return;
      event?.preventDefault();
      if (dialog.open) return;
      cancelAnimationFrame(restoreFrame); enlarged=false;
      photo.src=loaded?fullURL.href:(image.currentSrc||image.src);
      status.textContent=loaded?'':'Loading larger image…';
      lock();
      try { dialog.showModal();measure(true);close.focus({preventScroll:true}); }
      catch (_) { unlock();location.assign(fullURL.href);return; }
      if (!loaded) {
        const token=++generation;
        if(fullImage){fullImage.onload=null;fullImage.onerror=null;}
        fullImage=new Image();fullImage.decoding='async';
        fullImage.onload=()=>{if(disposed||token!==generation)return;loaded=true;photo.src=fullURL.href;status.textContent='';};
        fullImage.onerror=()=>{if(disposed||token!==generation)return;status.textContent='Full-size image unavailable. Preview shown.';};
        fullImage.src=fullURL.href;
      }
    }
    on(launch,'click',open);
    on(image,'click',open);
    on(close,'click',()=>dialog.close());
    on(dialog,'click',event=>{if(event.target===dialog)dialog.close();});
    on(dialog,'close',()=>unlock());
    on(zoom,'click',()=>{enlarged=!enlarged;measure(true);});
    on(dialog,'keydown',event=>{
      if(event.ctrlKey||event.altKey||event.metaKey)return;
      if(event.key==='+'||event.key==='='){event.preventDefault();enlarged=true;measure(true);}
      if(event.key==='-'||event.key==='0'){event.preventDefault();enlarged=false;measure(true);}
    });
    on(window,'resize',()=>{if(!resizeFrame)resizeFrame=requestAnimationFrame(()=>{resizeFrame=0;measure(true);});},{passive:true});
    let resize;
    if('ResizeObserver' in window){resize=new ResizeObserver(()=>measure());resize.observe(viewport);}
    on(window,'pagehide',()=>{if(dialog.open)dialog.close();unlock(false);});
    instances.set(root,()=>{
      disposed=true;abort.abort();resize?.disconnect();cancelAnimationFrame(resizeFrame);cancelAnimationFrame(restoreFrame);
      if(fullImage){fullImage.onload=null;fullImage.onerror=null;}
      if(dialog.open)dialog.close();unlock(false);dialog.remove();tools.remove();
      root.classList.remove('bmg-product-enlarge-ready');instances.delete(root);
    });
  }
  function init(){
    document.querySelectorAll('[data-bmg-catalogue]').forEach(collection);
    document.querySelectorAll('[data-bmg-product-root]').forEach(product);
  }
  document.addEventListener('shopify:section:load',()=>{[...instances.values()].forEach(dispose=>dispose());init();});
  document.addEventListener('shopify:section:unload',event=>{[...instances.entries()].forEach(([root,dispose])=>{if(event.target.contains(root))dispose();});});
  window.addEventListener('pageshow',init);
  window.BMGImageControls={init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
